import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import withConfig from 'config/withConfig';
import has from 'lodash/has';
import SearchMeta from 'search/SearchMeta';
import SegmentUtils from 'utils/segment';
import SHUtils from 'utils/sh-utils';
import ExperimentUtils from 'utils/experiment';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {getSpotsAirport} from 'spots/spots-actions';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import SearchAirportControls from 'common/airport/date-pickers/SearchAirportControls';
import SearchAirportResults from './results/SearchAirportResults';
import {Helmet} from 'react-helmet-async';

class SearchAirport extends PureComponent {
    static propTypes = {
        destination: PropTypes.shape(DESTINATION_DATA).isRequired,
        ends: PropTypes.string,
        hasUserInput: PropTypes.bool,
        loadAirportSpots: PropTypes.func.isRequired,
        starts: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this._isAirportShortenedDatepickerEnabled = ExperimentUtils.isFeatureEnabled(
            'airport_datepicker_test'
        );
        this._bodyClasses = SHUtils.determineInitialLoadBodyClasses({
            isSearchPage: true,
            isAirport: true,
        });
    }

    componentDidMount() {
        const {starts, ends} = this.props;

        if (starts && ends) {
            this._loadAirportSpots();
        }

        SegmentUtils.track({
            event: 'Search Landing',
        });

        SHUtils.staticScrollTo();
    }

    componentDidUpdate(prevProps, prevState) {
        const {starts: prevStarts, ends: prevEnds} = prevProps;
        const {starts, ends} = this.props;

        if (prevStarts !== starts || prevEnds !== ends) {
            this._loadAirportSpots();
        }
    }

    _loadAirportSpots = () => {
        this.props.loadAirportSpots().catch(error => {
            if (!has(error, 'isCanceled')) {
                SegmentUtils.track({
                    event: 'Error Message Displayed',
                    properties: {
                        'error message': 'Error fetching spots',
                        'error screen': 'search',
                        'error action': 'fetching spots',
                    },
                });
            }
        });
    };

    render() {
        const {
            hasUserInput,
            destination: {title},
        } = this.props;

        return (
            <div className="SearchAirport">
                <Helmet>
                    <body className={this._bodyClasses} />
                </Helmet>
                <SearchMeta />
                <h2 className="SearchAirport-airport-name">{title}</h2>
                <div className="SearchAirport-datepicker-container">
                    <SearchAirportControls
                        isAirportShortenedDatepickerEnabled={
                            this._isAirportShortenedDatepickerEnabled
                        }
                        title={title}
                        showCondensedMobileView
                    />
                </div>
                {hasUserInput && <SearchAirportResults />}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        city: {data: city},
        destination: {data: destination},
        searchRequest: {starts, ends},
    } = state;

    return {
        destination,
        city,
        starts,
        ends,
        hasUserInput: Boolean(starts && ends),
    };
};

const mapDispatchToProps = {
    loadAirportSpots: getSpotsAirport,
};

const enhance = compose(
    withConfig(['isMobile', 'siteUrl']),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
);

export default enhance(SearchAirport);
